import type { Length } from '@gitbook/api-client';

import { COLUMN_DIVISIONS } from './BlockColumns';

export function transformLengthToCSS(length: Length) {
    if (typeof length === 'number') {
        return; // not implemented yet with non-percentage lengths
    }
    if (length.unit === '%') {
        return {
            className: 'md:flex-shrink-0 md:[grid-column:var(--grid-col)]',
            style: {
                '--grid-col': `auto / span ${Math.round(length.value * 0.01 * COLUMN_DIVISIONS)}`,
            } as React.CSSProperties,
        };
    }
}
